import { styled } from '@mui/material/styles';
import { useLocalStorage } from '../../utils/useLocalStorage';
import { AiProviderKeysCard } from './AiProviderKeysCard';

export function AiReports() {
  const [accessToken = ''] = useLocalStorage('accessToken', '');

  return (
    <StyledCardContainer>
      <AiProviderKeysCard accessToken={accessToken} />
    </StyledCardContainer>
  );
}

const StyledCardContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  max-width: 1000px;
`;
